import {
  GET_MERCHANTS_REQUESTED,
  GET_MERCHANTS_SUCCEEDED,
  GET_MERCHANTS_FAILED,
  CREATE_MERCHANTS_REQUESTED,
  CREATE_MERCHANTS_SUCCEEDED,
  CREATE_MERCHANTS_FAILED,
  UPDATE_MERCHANTS_REQUESTED,
  UPDATE_MERCHANTS_SUCCEEDED,
  UPDATE_MERCHANTS_FAILED,
  DELETE_MERCHANTS_REQUESTED,
  DELETE_MERCHANTS_SUCCEEDED,
  DELETE_MERCHANTS_FAILED,
} from './constants'
import api from 'utils/api'

export const getMerchantsRequested = () => ({
  type: GET_MERCHANTS_REQUESTED,
})

export const getMerchantsSucceeded = (payload) => ({
  type: GET_MERCHANTS_SUCCEEDED,
  payload,
})

export const getMerchantsFailed = () => ({
  type: GET_MERCHANTS_FAILED,
})

export const createMerchantsRequested = () => ({
  type: CREATE_MERCHANTS_REQUESTED,
})

export const createMerchantsSucceeded = (payload) => ({
  type: CREATE_MERCHANTS_SUCCEEDED,
  payload,
})

export const createMerchantsFailed = () => ({
  type: CREATE_MERCHANTS_FAILED,
})

export const updateMerchantsRequested = () => ({
  type: UPDATE_MERCHANTS_REQUESTED,
})

export const updateMerchantsSucceeded = (payload) => ({
  type: UPDATE_MERCHANTS_SUCCEEDED,
  payload,
})

export const updateMerchantsFailed = () => ({
  type: UPDATE_MERCHANTS_FAILED,
})

export const deleteMerchantsRequested = () => ({
  type: DELETE_MERCHANTS_REQUESTED,
})

export const deleteMerchantsSucceeded = (payload) => ({
  type: DELETE_MERCHANTS_SUCCEEDED,
  payload,
})

export const deleteMerchantsFailed = () => ({
  type: DELETE_MERCHANTS_FAILED,
})

export const fetchMerchants =
  ({ venueUuid, per, page, searchFor, searchBy }) =>
  (dispatch) => {
    dispatch(getMerchantsRequested())

    return api
      .fetchMerchants(venueUuid, per, page, searchFor, searchBy)
      .then((response) => dispatch(getMerchantsSucceeded(response)))
      .catch(() => dispatch(getMerchantsFailed()))
  }

export const createMerchant = (data) => (dispatch) => {
  dispatch(createMerchantsRequested())

  return api
    .createMerchant(data)
    .then((response) =>
      dispatch(createMerchantsSucceeded(response?.data?.merchants))
    )
    .catch(() => dispatch(createMerchantsFailed()))
}

export const updateMerchant = (data) => (dispatch) => {
  dispatch(updateMerchantsRequested())

  return api
    .updateMerchant(data)
    .then((response) =>
      dispatch(updateMerchantsSucceeded(response?.data?.merchants))
    )
    .catch(() => dispatch(updateMerchantsFailed()))
}

export const deleteMerchant = (uuid) => (dispatch) => {
  dispatch(deleteMerchantsRequested())

  return api
    .deleteMerchant(uuid)
    .then((response) =>
      dispatch(deleteMerchantsSucceeded(response?.data?.merchants))
    )
    .catch(() => dispatch(deleteMerchantsFailed()))
}
